import {checkUnreadMessages} from '../../../api/messages'
import * as uiTypes from './types'

export function checkUnreadMessage({commit}) {
  return new Promise((resolve, reject) => {
    checkUnreadMessages()
      .then(({data}) => {
        commit(uiTypes.HAS_UNREAD_MESSAGE, data.unread_messages)

        resolve(data)
      })
      .catch((errors) => {
        reject(errors)
      })
  })
}


//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/store/modules/ui/actions.js
// module id = null
// module chunks = 